import './styles/index.scss';
import { Icon } from '@app/ui';
import React from 'react';
import {
  AudioMutedOutlined,
  AudioOutlined,
  AuditOutlined,
  BankOutlined,
  BarsOutlined,
  BookOutlined,
  CarryOutOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CopyOutlined,
  DatabaseOutlined,
  DollarOutlined,
  DownOutlined,
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  ExperimentOutlined,
  ExportOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  FileDoneOutlined,
  GlobalOutlined,
  HeartOutlined,
  HomeOutlined,
  ImportOutlined,
  LeftCircleOutlined,
  LineChartOutlined,
  MailOutlined,
  MedicineBoxOutlined,
  MonitorOutlined,
  PhoneOutlined,
  PicRightOutlined,
  PlusOutlined,
  PushpinOutlined,
  RightCircleOutlined,
  ScheduleOutlined,
  SelectOutlined,
  SyncOutlined,
  UpOutlined,
  SoundOutlined,
  LaptopOutlined,
  CommentOutlined,
  SnippetsOutlined,
  FolderOutlined,
  FolderAddOutlined,
  FileAddOutlined,
  ArrowLeftOutlined,
  AreaChartOutlined,
  BarChartOutlined,
  InfoCircleOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  IdcardOutlined,
  MobileOutlined,
  HistoryOutlined,
  MessageOutlined,
  FileExclamationOutlined,
  EnvironmentOutlined,
  WarningOutlined,
  BellOutlined,
  UsergroupAddOutlined,
  TeamOutlined,
  OpenAIOutlined,
  ClearOutlined,
  PrinterOutlined,
} from '@ant-design/icons';
import LogoUrl from './images/logo.png?url';
import PdfLogoUrl from './images/sightwatcher-logo.png?url';
import { convertImageToBase64 } from '@app/common/utils';

export { LogoUrl, PdfLogoUrl };

export async function importLogoBase64(): Promise<string> {
  return await fetch(LogoUrl)
    .then((x) => x.blob())
    .then(convertImageToBase64);
}

export async function importPdfLogoBase64(): Promise<string> {
  return await fetch(PdfLogoUrl)
    .then((x) => x.blob())
    .then(convertImageToBase64);
}

const CUSTOM_ICONS = {
  add: PlusOutlined,
  book: BookOutlined,
  'check-circle': CheckCircleOutlined,
  'exclamation-circle': ExclamationCircleOutlined,
  'exclamation-circle-filled': ExclamationCircleFilled,
  pin: PushpinOutlined,
  sync: SyncOutlined,
  clock: ClockCircleOutlined,
  audio: AudioOutlined,
  'audio-off': AudioMutedOutlined,
  bars: BarsOutlined,
  address: HomeOutlined,
  phone: PhoneOutlined,
  email: MailOutlined,
  heart: HeartOutlined,
  file: FileDoneOutlined,
  global: GlobalOutlined,
  schedule: ScheduleOutlined,
  monitor: MonitorOutlined,
  carry: CarryOutOutlined,
  up: UpOutlined,
  down: DownOutlined,
  bank: BankOutlined,
  watch: EyeOutlined,
  unwatch: EyeInvisibleOutlined,
  open: ExportOutlined,
  'open-thread': PicRightOutlined,
  select: SelectOutlined,
  copy: CopyOutlined,
  medication: MedicineBoxOutlined,
  experiment: ExperimentOutlined,
  'line-chart': LineChartOutlined,
  test: AuditOutlined,
  finance: DollarOutlined,
  import: ImportOutlined,
  'data-transfer': DatabaseOutlined,
  sound: SoundOutlined,
  laptop: LaptopOutlined,
  comment: CommentOutlined,
  'circle-left': LeftCircleOutlined,
  'circle-right': RightCircleOutlined,
  snippets: SnippetsOutlined,
  folder: FolderOutlined,
  'add-folder': FolderAddOutlined,
  'add-file': FileAddOutlined,
  'full-arrow-left': ArrowLeftOutlined,
  'area-chart': AreaChartOutlined,
  'bar-chart': BarChartOutlined,
  'info-circle': InfoCircleOutlined,
  'full-arrow-up': ArrowUpOutlined,
  'full-arrow-down': ArrowDownOutlined,
  identifier: IdcardOutlined,
  mobile: MobileOutlined,
  history: HistoryOutlined,
  location: EnvironmentOutlined,
  chat: MessageOutlined,
  'file-exclamation': FileExclamationOutlined,
  warning: WarningOutlined,
  bell: BellOutlined,
  group: UsergroupAddOutlined,
  team: TeamOutlined,
  ai: OpenAIOutlined,
  clear: ClearOutlined,
  print: PrinterOutlined,
};

const icons: Record<string, { default: React.ComponentType }> = import.meta.glob('./images/icons/*.svg', {
  eager: true,
  query: '?react',
});

Object.entries(icons).forEach(([file, value]) => {
  const key = file.replace('./images/icons/', '').replace('.svg', '');
  Icon.addSvg(key as any, value.default);
});

Object.entries(CUSTOM_ICONS).forEach(([key, value]) => Icon.add(key, value));
